export enum MailboxFolderType {
  NORMAL = 'NORMAL',
  INBOX = 'INBOX',
  DRAFTS = 'DRAFTS',
  OUTBOX = 'OUTBOX',
  SENT_ITEMS = 'SENT_ITEMS',
  DELETED = 'DELETED',
}
